import React from 'react';
import PropTypes from 'prop-types';
import { UilCheck } from '@iconscout/react-unicons';

const colors = [
  {
    id: 1,
    color: 'border border-blue-cornflower bg-blue-magnolia',
    value: '#0025B8',
    checkedColor: '#0025B8',
    isSelected: true,
  },
  {
    id: 2,
    color: 'border border-gray-silver bg-gray-culture',
    value: '#5C5C5C',
    checkedColor: '#5C5C5C',
    isSelected: false,
  },
  {
    id: 3,
    color: 'border border-green-mint bg-green-nyanza',
    value: '#086336',
    checkedColor: '#086336',
    isSelected: false,
  },
  {
    id: 4,
    color: 'border border-red-coral bg-red-blush',
    value: '#086336',
    checkedColor: '#B80006',
    isSelected: false,
  },
  {
    id: 5,
    color: 'border border-orange-salmon bg-orange-seashell',
    value: '#B84300',
    checkedColor: '#B84300',
    isSelected: false,
  },
  {
    id: 6,
    color: 'border border-purple-heliotrop bg-purple-pale',
    value: '#8100B8',
    checkedColor: '#8100B8',
    isSelected: false,
  },
  {
    id: 7,
    color: 'border border-gray-culture bg-neutral-light',
    value: '#000D23',
    checkedColor: '#C2C2C2',
    isSelected: false,
  },
  {
    id: 8,
    color: 'bg-blue-shark',
    value: '#FFFFFF',
    checkedColor: '#FFFFFF',
    isSelected: false,
  },
  {
    id: 9,
    color: 'bg-gray-davys',
    value: '#FFFFFF',
    checkedColor: '#FFFFFF',
    isSelected: false,
  },
  {
    id: 10,
    color: 'bg-green-viggie',
    value: '#FFFFFF',
    checkedColor: '#FFFFFF',
    isSelected: false,
  },
  {
    id: 11,
    color: 'bg-red-engine',
    value: '#FFFFFF',
    checkedColor: '#FFFFFF',
    isSelected: false,
  },
  {
    id: 12,
    color: 'bg-orange-mahogany',
    value: '#FFFFFF',
    checkedColor: '#FFFFFF',
    isSelected: false,
  },
  {
    id: 13,
    color: 'bg-purple-violet',
    value: '#FFFFFF',
    checkedColor: '#FFFFFF',
    isSelected: false,
  },
  {
    id: 14,
    color: 'bg-neutral-dark',
    value: '#FFFFFF',
    checkedColor: '#FFFFFF',
    isSelected: false,
  },
];
const ColorPicker = (props) => {
  const { color = colors, onSelect } = props;

  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    setData(color);
  }, [color]);

  return (
    <div className="p-3 grid grid-cols-7 gap-2 rounded-lg shadow-lg">
      {data &&
        data.map((item) => {
          return (
            <div
              onClick={() => onSelect(item.id, item.value)}
              key={item.id}
              className={`w-10 h-10 rounded-md cursor-pointer flex justify-center items-center ${item.color}`}
            >
              {item.isSelected && <UilCheck size="30" color={item.checkedColor} />}
            </div>
          );
        })}
    </div>
  );
};

ColorPicker.propTypes = {
  color: PropTypes.array,
  onSelect: PropTypes.func,
};

export default ColorPicker;
